import React, { useState, useEffect } from 'react';
import {
    Card,
    CardBody,
    CardFooter,
    CardTitle,
    Button,
    InputGroup,
    Alert,
    Row,
    Col,
} from 'reactstrap';
import Logo from '../../assets/img/inspectalyLogo.png';
import { BASE_URL } from "../../constants";
import axios from 'axios';

const AccountDelete = () => {
    const [email, setEmail] = useState('');
    const [deleteToken, setDeleteToken] = useState('');
    const [isVerified, setIsVerified] = useState(false);
    const [isDeleted, setIsDeleted] = useState(false);
    const [errMsg, setErrMsg] = useState(null);

    useEffect(() => {
        const savedIsVerified = localStorage.getItem('isVerified');
        const savedEmail = localStorage.getItem('email');
        if (savedIsVerified === 'true') {
            setIsVerified(true);
            setEmail(savedEmail || '');
        }
    }, []);

    useEffect(() => {
        localStorage.setItem('isVerified', isVerified);
        if (isVerified) {
            localStorage.setItem('email', email);
        } else {
            localStorage.removeItem('email');
        }
    }, [isVerified]);

    const handleAccountDeletion = async () => {
        if (deleteToken) {
            try {
                const response = await axios.post(`${BASE_URL}/auth/account-delete`, {
                    email: email,
                    delete_token: deleteToken,
                });

                if (response.data.status) {
                    setErrMsg('Account deletion successful.');
                    setIsDeleted(true);
                    setEmail('');
                    setDeleteToken('');
                    setIsVerified(false);
                } else {
                    setErrMsg(response.data.message || 'Something went wrong.');
                }
                localStorage.clear(); 

            } catch (error) {
                setErrMsg(
                    error.response?.data?.message || 'An error occurred while submitting your request.'
                );
            }
        } else {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (!email) {
                setErrMsg('Please enter a valid email address.');
                return;
            }

            if (!emailRegex.test(email)) {
                setErrMsg('Invalid email format. Please enter a valid email address.');
                return;
            }

            try {
                const response = await axios.post(`${BASE_URL}/auth/verify-user-email`, {
                    email: email,
                });

                if (response.data.status) {
                    setErrMsg(response.data.message);
                    setIsVerified(true);
                } else {
                    setErrMsg(response.data.message || 'Something went wrong.');
                }
            } catch (error) {
                setErrMsg(
                    error.response?.data?.message || 'An error occurred while submitting your request.'
                );
            }
        }
    };

    return (
        <div style={{ minHeight: '100vh', background: 'rgb(244, 243, 239)' }}>
            <div style={{ display: 'flex', justifyContent: 'center' }}>
                <img src={Logo} alt="Logo" width="250" height="auto" draggable="false" />
            </div>
            <Card
                style={{
                    width: '90%',
                    maxWidth: '50rem',
                    marginLeft: 'auto',
                    marginRight: 'auto',
                    padding: '20px',
                    paddingBottom: '20px',
                }}
            >
                {errMsg !== null && <Alert color="danger">{errMsg}</Alert>}

                {!isDeleted ? (
                    <CardBody>
                        <CardTitle tag="h3" className="text-center mb-4">
                            Request for Account Deletion
                        </CardTitle>
                        <p className="text-muted text-center mb-3">
                            Send a request to delete your account and personally identifiable information (PII)
                            that is stored on our system. You will receive an email to verify your request. Once the
                            request is verified, we will take care of deleting your PII.
                        </p>
                        <p className="text-danger text-center">
                            <strong> Note: Your request for account deletion will be fulfilled within 3 days.</strong>
                        </p>
                        <CardTitle>{isVerified ? 'Delete Token' : 'Email'}</CardTitle>
                        <InputGroup>
                            {isVerified ? (
                                <input
                                    type="text"
                                    className="form-control user-select-none"
                                    autoFocus
                                    value={deleteToken}
                                    onChange={(e) => setDeleteToken(e.target.value)}
                                    placeholder="Enter the Delete token"
                                />
                            ) : (
                                <input
                                    type="email"
                                    className="form-control user-select-none"
                                    autoFocus
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    placeholder="Enter your email"
                                />
                            )}
                        </InputGroup>
                    </CardBody>
                ) : (
                    <CardBody>
                        <CardTitle tag="h3" className="text-center mb-4">
                            Account Deletion Successful
                        </CardTitle>
                        <p className="text-center text-success">
                            Your account has been successfully deleted. All your personal information has been removed from our system.
                        </p>
                    </CardBody>
                )}

                {!isDeleted && (
                    <CardFooter>
                        <Row className="d-flex justify-content-end">
                            <Col xs="auto">
                                <Button color="primary" className="px-5" size="md" onClick={handleAccountDeletion}>
                                    Submit
                                </Button>
                            </Col>
                        </Row>
                    </CardFooter>
                )}
            </Card>
        </div>
    );
};

export default AccountDelete;
